// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1hx98","subheader":"ReorderModal_subheader__1ee-q","listWrap":"ReorderModal_listWrap__1tw8F"};